import { pluginCategories } from '@tunasong/plugin-lib'
import type { PluginCategory, Template, TunaPlugin } from '@tunasong/plugin-lib'
import { entityTypeNames } from '@tunasong/schemas'
import type { EntityType } from '@tunasong/schemas'
import type React from 'react'
import { useCallback, useState } from 'react'
import type { FC } from 'react'
import { getCreateEntityPlugins } from '@tunasong/plugin-lib'
import TemplateGrid from './template-grid.js'
import { Tab, Tabs, capitalize } from '@tunasong/ui-lib'
import styles from './create-entity-grid.module.css'

interface CreateEntityGridProps {
  plugins: TunaPlugin[]
  selected?: Template
  /** @default true */
  showCategories?: boolean
  allowedChildEntities?: readonly EntityType[]
  onSelect: (template: Template | null) => void
}

/** Grid of Entity templates */
export const CreateEntityGrid: FC<CreateEntityGridProps> = props => {
  const { onSelect, showCategories = true, allowedChildEntities = entityTypeNames, plugins } = props

  const [activeCategory, setActiveCategory] = useState<PluginCategory>('main')
  const handleTab = useCallback(
    (_ev: React.SyntheticEvent | null, value: string | number) => {
      const category = value as PluginCategory
      setActiveCategory(category)
      onSelect(null)
    },
    [onSelect]
  )

  /** All createPlugins have at least one template */
  const getPluginsForCategory = (category: PluginCategory) =>
    getCreateEntityPlugins({
      plugins,
      category,
      allowedTypes: allowedChildEntities,
    })

  return (
    <>
      {showCategories ? (
        <Tabs className={styles.tabs} value={activeCategory} onChange={handleTab} scrollButtons variant="scrollable">
          {pluginCategories.map(category => {
            const plugins = getPluginsForCategory(category)
            if (plugins.length === 0) {
              return null
            }
            return <Tab key={category} label={capitalize(category)} value={category} />
          })}
        </Tabs>
      ) : null}
      <TemplateGrid plugins={getPluginsForCategory(activeCategory)} onSelect={onSelect} />
    </>
  )
}

export default CreateEntityGrid
